import invariant from 'tiny-invariant';

import { useAppConfiguration } from '../../context/app-configuration/useAppConfiguration';
import { type BffGetConfigurationsResponseModeOfTransportOption } from '../../generated/api-client';

/**
 * @returns the default secondary transport mode.
 * If a transport mode code is provided, it will return the corresponding item from the configuration.
 * If no transport mode code is provided, it will return the "road" transport mode from the configuration.
 */
export const useDefaultSecondaryMot = (
  transportModeCode?: BffGetConfigurationsResponseModeOfTransportOption['name'],
) => {
  const { secondaries_modes_of_transport } = useAppConfiguration();
  const roadMot = secondaries_modes_of_transport.find(
    (mot) => mot.name === 'road',
  );

  invariant(
    roadMot,
    'Road MOT should always be available for secondary transport mode.',
  );

  if (!transportModeCode) {
    return roadMot;
  }

  const mot = secondaries_modes_of_transport.find(
    (mot) => mot.name === transportModeCode,
  );

  invariant(mot, 'Secondary transport mode not found in configuration.');

  return mot;
};
